// Theme: phoenix
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'phoenix',
  name: 'PHOENIX',
  tagline: 'PHOENIX',
  description: 'Fogo ascendente laranja-dourado de renascimento.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0D0604', '#201008', '#F97316', '#FFF7ED'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-phoenix'
  },
  colorVars: {
    '--accent': '#F97316',
    '--accent-foreground': '#0D0604',
    '--background': '#0D0604',
    '--border': '#8A4010',
    '--card': '#201008',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF7ED',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D0604',
    '--foreground': '#FFF7ED',
    '--hold-fill': '#F97316',
    '--input': '#8A4010',
    '--modal-bg': '#0D0604',
    '--modal-border': '#8A4010',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A4010',
    '--muted-foreground': '#FFF7ED',
    '--nav-active': '#F97316',
    '--nav-bg': '#201008',
    '--popover': '#201008',
    '--popover-foreground': '#FFF7ED',
    '--primary': '#F97316',
    '--primary-foreground': '#0D0604',
    '--ring': '#F97316',
    '--secondary': '#8A4010',
    '--secondary-foreground': '#FFF7ED',
    '--streak': '#F97316',
    '--success': '#22c55e',
    '--success-foreground': '#0D0604',
    '--xp': '#F97316',
    '--xp-bg': '#201008'
  },
  resolvedVars: {
    '--accent': '#F97316',
    '--accent-foreground': '#0D0604',
    '--accent-foreground-hsl': '13 53% 3%',
    '--accent-foreground-oklch': 'from #0D0604 l c h',
    '--accent-hsl': '25 95% 53%',
    '--accent-oklch': 'from #F97316 l c h',
    '--background': '#0D0604',
    '--background-hsl': '13 53% 3%',
    '--background-oklch': 'from #0D0604 l c h',
    '--border': '#8A4010',
    '--border-hsl': '24 79% 30%',
    '--border-oklch': 'from #8A4010 l c h',
    '--border-w': '1px',
    '--card': '#201008',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF7ED',
    '--card-foreground-hsl': '33 100% 96%',
    '--card-foreground-oklch': 'from #FFF7ED l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '20 60% 8%',
    '--card-oklch': 'from #201008 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D0604',
    '--destructive-foreground-hsl': '13 53% 3%',
    '--destructive-foreground-oklch': 'from #0D0604 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFF7ED',
    '--foreground-hsl': '33 100% 96%',
    '--foreground-oklch': 'from #FFF7ED l c h',
    '--hold-fill': '#F97316',
    '--hold-fill-hsl': '25 95% 53%',
    '--hold-fill-oklch': 'from #F97316 l c h',
    '--input': '#8A4010',
    '--input-hsl': '24 79% 30%',
    '--input-oklch': 'from #8A4010 l c h',
    '--modal-bg': '#0D0604',
    '--modal-bg-hsl': '13 53% 3%',
    '--modal-bg-oklch': 'from #0D0604 l c h',
    '--modal-border': '#8A4010',
    '--modal-border-hsl': '24 79% 30%',
    '--modal-border-oklch': 'from #8A4010 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A4010',
    '--muted-foreground': '#FFF7ED',
    '--muted-foreground-hsl': '33 100% 96%',
    '--muted-foreground-oklch': 'from #FFF7ED l c h',
    '--muted-hsl': '24 79% 30%',
    '--muted-oklch': 'from #8A4010 l c h',
    '--nav-active': '#F97316',
    '--nav-active-hsl': '25 95% 53%',
    '--nav-active-oklch': 'from #F97316 l c h',
    '--nav-bg': '#201008',
    '--nav-bg-hsl': '20 60% 8%',
    '--nav-bg-oklch': 'from #201008 l c h',
    '--popover': '#201008',
    '--popover-foreground': '#FFF7ED',
    '--popover-foreground-hsl': '33 100% 96%',
    '--popover-foreground-oklch': 'from #FFF7ED l c h',
    '--popover-hsl': '20 60% 8%',
    '--popover-oklch': 'from #201008 l c h',
    '--primary': '#F97316',
    '--primary-foreground': '#0D0604',
    '--primary-foreground-hsl': '13 53% 3%',
    '--primary-foreground-oklch': 'from #0D0604 l c h',
    '--primary-hsl': '25 95% 53%',
    '--primary-oklch': 'from #F97316 l c h',
    '--radius': '12px',
    '--ring': '#F97316',
    '--ring-hsl': '25 95% 53%',
    '--ring-oklch': 'from #F97316 l c h',
    '--secondary': '#8A4010',
    '--secondary-foreground': '#FFF7ED',
    '--secondary-foreground-hsl': '33 100% 96%',
    '--secondary-foreground-oklch': 'from #FFF7ED l c h',
    '--secondary-hsl': '24 79% 30%',
    '--secondary-oklch': 'from #8A4010 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#F97316',
    '--streak-hsl': '25 95% 53%',
    '--streak-oklch': 'from #F97316 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0D0604',
    '--success-foreground-hsl': '13 53% 3%',
    '--success-foreground-oklch': 'from #0D0604 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(25 95% 53% / 0.15)',
    '--xp': '#F97316',
    '--xp-bg': '#201008',
    '--xp-bg-hsl': '20 60% 8%',
    '--xp-bg-oklch': 'from #201008 l c h',
    '--xp-hsl': '25 95% 53%',
    '--xp-oklch': 'from #F97316 l c h'
  }
}
